import sanitizeHtml from 'sanitize-html'
import Vue from 'vue'
import VueSanitize from 'vue-sanitize'

declare module 'vue/types/vue' {
  interface Vue {
    $sanitize: (dirty: string, opts?: object) => typeof sanitizeHtml
  }
}

Vue.use(VueSanitize)
